import React, {useEffect} from 'react'
import {useColorScheme} from '@mui/material/styles'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import {styled} from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    minWidth: '31px',
    height: '31px',
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: -1,
      borderLeft: '1px solid transparent',
    },
}))

function Mode({setLightDarkMode}) {
  const {mode, setMode} = useColorScheme()

  useEffect(() => setLightDarkMode(mode))
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          width: 'fit-content',
          position: 'absolute',
          right: 16,
          top: 17,
        }}
        className="mode-switcher"
      >
        <Paper
          elevation={0}
          sx={theme => ({
            display: 'flex',
            border: `1px solid ${theme.palette.divider}`,
            flexWrap: 'wrap',
            flexDirection: 'row',
            alignItems: 'center',
          })}
        >
          <StyledToggleButtonGroup
            size="small"
            value={mode}
            exclusive
            onChange={(event, newMode) => {
              if (newMode !== null) {
                setMode(newMode)
                setLightDarkMode(newMode)
              }
            }}
            aria-label="demo-theme-toggle"
          >
            <ToggleButton value="light" aria-label="Light">
              <LightModeOutlinedIcon />
            </ToggleButton>
            <ToggleButton value="dark" aria-label="Dark">
              <DarkModeOutlinedIcon />
            </ToggleButton>
          </StyledToggleButtonGroup>
        </Paper>
      </Box>
    </>
  )
}

export default Mode
